import { Draw } from 'ol/interaction';
import { Vector as VectorLayer } from 'ol/layer';
import { Vector as VectorSource } from 'ol/source';
import { getArea, getLength } from 'ol/sphere';

export default {
  computed: {
    isMeasurementsToolActive() {
      return this.activeControl === 'measurements';
    },
  },
  methods: {
    formatArea(geometry) {
      const area = getArea(geometry);
      if (area > 1000000) {
        return `${Math.round((area / 1000000) * 100) / 100} km2`;
      } else if (area > 10000) {
        return `${Math.round((area / 10000) * 100) / 100} ha`;
      }
      return `${Math.round(area * 100) / 100} m2`;
    },
    formatLength(geometry) {
      const length = getLength(geometry);
      if (length > 1000) {
        return `${Math.round((length / 1000) * 100) / 100} km`;
      }
      return `${Math.round(length * 100) / 100} m`;
    },
    getMeasurementStyle(feature, type) {
      const geometry = feature.getGeometry();
      return [
        ...this.getPointMeasurementStyles(geometry),
        ...(type === 'Polygon' ? this.getAreaMeasurementStyles(geometry) : this.getLengthMeasurementStyles(geometry)),
      ];
    },
    getPolygonMeasurementLabel(geometry) {
      return `${this.$i18n.t('default.area')}: ${this.formatArea(geometry)}
      ${this.$i18n.t('default.perimeter')}: ${this.formatLength(geometry)}`;
    },
    addMeasurement(type) {
      this.$root.$emit('toggleIdentification', false);
      const drawLayer = this.addMeasurementLayer(type);
      this.addMeasurementInteraction(drawLayer, type);
    },
    addMeasurementLayer(type) {
      const layer = new VectorLayer({
        source: new VectorSource({}),
        name: 'measurement',
        style: feature => this.getMeasurementStyle(feature, type),
      });
      layer.setZIndex(999);
      this.map.addLayer(layer);
      return layer;
    },
    addMeasurementInteraction(layer, type) {
      const measurementInteraction = new Draw({
        source: layer.getSource(),
        type: type,
        style: feature => this.getMeasurementStyle(feature, type),
      });
      measurementInteraction.set('name', 'measurement');
      measurementInteraction.on('drawstart', () => {
        this.getLayerBy('measurement', { by: 'name' }).getSource().clear();
      });
      this.map.addInteraction(measurementInteraction);
      this.activeControl = 'measurements';
    },
    clearMeasurementInteraction() {
      this.map.removeInteraction(this.getInteractionByName('measurement'));
      this.map.removeLayer(this.getLayerBy('measurement', { by: 'name' }));
      this.$root.$emit('toggleIdentification', true);
    },
    turnOffMeasurementsInteraction() {
      this.map.removeInteraction(this.getInteractionByName('measurement'));
    },
  },
  watch: {
    activeControl(nV, oV) {
      if (oV === 'measurements' && nV !== 'measurements') {
        this.clearMeasurementInteraction();
      }
    },
  },
};
